/*
 * Public API Surface of ng-chartjs
 */
export * from './lib/ng-chartjs.directive';
export * from './lib/ng-chartjs.module';
export * from './lib/ng-chartjs.service';
export * from './lib/colors';
